module.exports = __webpack_public_path__ + "media/common/img/feedback-8774a336d6c479a5ad232be965e9c1d1.svg";